module.exports = __webpack_public_path__ + "img/face-emoticon3.8550eb76.svg";